<template>
    <div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="txtComments">Comments</label>
                    <textarea id="txtComments" name="txtComments" class="form-control generic-textbox" cols="2" rows="2" v-model="call.Comments" :readonly="readOnly"></textarea>
                </div>
            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>

    textarea {
        resize: vertical;
    }

</style>

<script>
    export default {

        props: {
            call: Object,
            readOnly: Boolean,
        },

    }
</script>

